import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GoogleAdsTracker from "./GoogleAdsTracker"; // Importiere das Tracking
import { OrganizationSchema, WebSiteSchema } from "./components/StructuredData";

// Alle Seiten importieren
import Start from "./pages/Start";
import About from "./pages/About";
import SolarModules from "./pages/SolarModules";
import StorageSystems from "./pages/StorageSystems";
import Wallbox from "./pages/Wallbox";
import Gateway from "./pages/Gateway";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import CalculatorP from "./pages/CalculatorP.js";
import CalculatorWRF from "./pages/CalculatorWRF.js";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ISPF from "./pages/ISPF";
import PriceCalculator from "./pages/CalculatorPrices.js";
import EnergyManagement from "./pages/EnergyManagement.js";
import PrivateAnfrage from "./pages/MesseAnfrage.js";
import NotFound from "./pages/NotFound.js";
import Waermepumpe from "./pages/Waermepumpe.js";
import Notstrom from "./pages/Notstrom.js";
import SolarSteps from "./pages/SolarSteps.js";

import { useDocTitle } from "./components/CustomHook";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [, setConsentGiven] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("cookieConsent") === "true") {
      setConsentGiven(true);
    }
  }, []);

  useDocTitle("Schmid Energieberatung");

  return (
    <Router>
      {/* Strukturierte Daten für SEO */}
      <OrganizationSchema />
      <WebSiteSchema />

      <GoogleAdsTracker /> {/* Tracking innerhalb des Router-Kontexts */}
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<Start />} />
          <Route path="/solarmodule" element={<SolarModules />} />
          <Route path="/stromspeicher" element={<StorageSystems />} />
          <Route path="/wallbox" element={<Wallbox />} />
          <Route path="/gateway" element={<Gateway />} />
          <Route path="/ueber-uns" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/kundenrezensionen" element={<Testimonials />} />
          <Route path="/sanierungsfahrplan" element={<ISPF />} />
          <Route path="/foerderrechner-waermepumpe" element={<CalculatorP />} />
          <Route path="/foerderrechner-fenster-dach-fassade" element={<CalculatorWRF />} />
          <Route path="/impressum" element={<LegalNotice />} />
          <Route path="/datenschutz" element={<PrivacyPolicy />} />
          <Route path="/preiskalkulation" element={<PriceCalculator />} />
          <Route path="/energiemanagement" element={<EnergyManagement />} />
          <Route path="/anfrage" element={<PrivateAnfrage />} />
          <Route path="/waermepumpe" element={<Waermepumpe />} />
          <Route path="/notstrom" element={<Notstrom />} />
          <Route path="/solaranlage-schritte" element={<SolarSteps />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ScrollToTop>

      {/* Cookie Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Akzeptieren"
        declineButtonText="Ablehnen"
        onAccept={() => {
          localStorage.setItem("cookieConsent", "true");
          setConsentGiven(true);
        }}
        onDecline={() => {
          localStorage.setItem("cookieConsent", "false");
        }}
      >
        Wir verwenden Cookies für Analyse- und Werbezwecke. Mehr dazu in unserer{" "}
        <a href="/datenschutz" className="datenschutz-link">
          Datenschutzerklärung
        </a>.
      </CookieConsent>
    </Router>
  );
}

export default App;